import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { DisplayList, NODE_TYPE } from './displayList';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

@Component({
    selector: 'app-display-list',
    templateUrl: './display-list.component.html',
    styleUrls: ['./display-list.component.scss'],
    imports: [ReactiveFormsModule, ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ClickatellFormValidationComponent, ActiveFormDirective, MatSlideToggle, CMSComponent, NextSelectorComponent]
})
export class DisplayListComponent extends NodeBuilder implements OnInit {

  displayListForm: UntypedFormGroup;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.displayListForm = DisplayList.toForm(stepData, this.canEdit);

    if (this.displayListForm.get('yes').value === newStepValue) {
      this.displayListForm.get('yes').setValue('step' + this.getNextStep());
    }
    if (this.displayListForm.get('no').value === newStepValue) {
      this.displayListForm.get('no').setValue('step' + this.getNextStep());
    }
  }

  get getStepData(): {} {
    const formData = this.displayListForm.getRawValue();
    const remap = new DisplayList();
    remap.setNodeData(formData);
    return remap.nodeData;
  }

  get isNodeValid(): boolean {
    this.displayListForm.markAllAsTouched();
    return this.displayListForm.valid;
  }
}
